import { grouperJoursConsecutifs, lendemainDuJour } from '@repere/core';

/**
 * Des jours cochés sur un calendrier, rendus dans la forme que l'API attend.
 *
 * Écrit une fois pour les deux bouts de la négociation — la demande d'échange et la
 * contre-proposition. Les deux construisaient leur tableau de périodes à la main, et les
 * deux ne le faisaient pas pareil : la contre-proposition envoyait une fin à minuit, ce
 * qui rendait une journée seule vide et la faisait refuser par le serveur
 * (`lirePeriodes`), alors que la demande d'échange avait déjà corrigé ce défaut chez elle.
 *
 * Une période par série de jours consécutifs. Deux jours qui ne se suivent pas font deux
 * périodes : « le samedi et le samedi suivant » ne doit pas emporter la semaine entre les
 * deux, ce qu'une période unique du premier au dernier ferait sans le dire.
 *
 * « Du 28 au 28 » désigne toute la journée du 28, pas un intervalle vide : la fin va au
 * début du jour suivant.
 */
export interface PeriodeDemandee {
  from: string;
  to: string;
  parentSlot: number;
}

export const periodesDemandees = (
  jours: readonly string[],
  parentSlot: number,
): PeriodeDemandee[] =>
  grouperJoursConsecutifs(jours).map((serie) => ({
    from: new Date(`${serie[0]}T00:00:00`).toISOString(),
    to: new Date(`${lendemainDuJour(serie[serie.length - 1]!)}T00:00:00`).toISOString(),
    parentSlot,
  }));
